// import React, { useState, useEffect } from 'react';
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Typography, Tooltip, TextField, MenuItem, Select } from '@mui/material';
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";
// import { tokens } from "../../theme";
// import "./ApproveLeave.css"

// function ApproveLeave() {
//   const [applications, setApplications] = useState([]);
//   const [message, setMessage] = useState('');
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [leaveUpdates, setLeaveUpdates] = useState({}); // Store updated values for each row

  
//   function gedata(){
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application`)
//     .then(res => res.json())
//     .then(data => {
//       const rowsWithId = data.map((row, index) => ({
//         id: index + 1, 
//         ...row,
//         EL: row.emergencyleave, // Add emergencyleave as EL
//         PL: row.plannedleave,    // Add plannedleave as PL
//       }));
//       setApplications(rowsWithId);
//     })
//     .catch(error => console.log(error));
//   }

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application`)
//       .then(res => res.json())
//       .then(data => {
//         const rowsWithId = data.map((row, index) => ({
//           id: index + 1, 
//           ...row,
//           EL: row.emergencyleave, // Add emergencyleave as EL
//           PL: row.plannedleave,    // Add plannedleave as PL
//         }));
//         setApplications(rowsWithId);
//       })
//       .catch(error => console.log(error));
//   }, []);

//   const handleUpdate = (applicationno, status) => {
//     const updatedRow = applications.find(application => application.applicationno === applicationno);
//     const { actualapproveleave, comments } = leaveUpdates[applicationno] || {}; // Get updated values

//     const updatedApplications = applications.map(application => 
//       application.applicationno === applicationno 
//         ? { ...application, ApplicationStatus: status, actualapproveleave, comments } 
//         : application
//     );

//     const updatedApplicationData = [
//       {
//         applicationno: updatedRow.applicationno,
//         ApplicationStatus: status,
//         userEmail: updatedRow.userEmail,
//         leavetype: updatedRow.leavetype,
//         LeavePurpose: updatedRow.LeavePurpose,
//         noofdays: updatedRow.noofdays,
//         startingdate: updatedRow.startingdate,
//         endingdate: updatedRow.endingdate,
//         startingdateleavesession: updatedRow.startingdateleavesession,
//         endingdateleavesession: updatedRow.endingdateleavesession,
//         ApplyingDate: updatedRow.ApplyingDate,
//         actualapproveleave: actualapproveleave || updatedRow.actualapproveleave, // Use updated or existing value
//         comments: comments || updatedRow.comments, // Use updated or existing value
//       },
//     ];

//     console.log("UPDATED APPLICATION data", updatedApplicationData);
    
//     const requestOptions = {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(updatedApplicationData),
//     };

//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-update`, requestOptions)
//       .then(res => res.json())
//       .then(() => {
//         setMessage('Status updated successfully');
//         setApplications(updatedApplications);
//         gedata();
//       })
//       .catch(error => console.log(error));

     

      


//   };




//   const handleUpdatecancellation = (applicationno, status) => {
//     const updatedRow = applications.find(application => application.applicationno === applicationno);
//     const { actualapproveleave, comments } = leaveUpdates[applicationno] || {}; // Get updated values

//     const updatedApplications = applications.map(application => 
//       application.applicationno === applicationno 
//         ? { ...application, ApplicationStatus: status, actualapproveleave, comments } 
//         : application
//     );

//     const updatedApplicationData = [
//       {
//         applicationno: updatedRow.applicationno,
//         ApplicationStatus: status,
//         userEmail: updatedRow.userEmail,
//         leavetype: updatedRow.leavetype,
//         LeavePurpose: updatedRow.LeavePurpose,
//         noofdays: updatedRow.noofdays,
//         startingdate: updatedRow.startingdate,
//         endingdate: updatedRow.endingdate,
//         startingdateleavesession: updatedRow.startingdateleavesession,
//         endingdateleavesession: updatedRow.endingdateleavesession,
//         ApplyingDate: updatedRow.ApplyingDate,
//         actualapproveleave: actualapproveleave || updatedRow.actualapproveleave, // Use updated or existing value
//         comments: comments || updatedRow.comments, // Use updated or existing value
//       },
//     ];

//     console.log("UPDATED APPLICATION data", updatedApplicationData);
    
//     const requestOptions = {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(updatedApplicationData),
//     };



//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-update-cancellation`, requestOptions)
//       .then(res => res.json())
//       .then(() => {
//         setMessage('Status updated successfully');
//         setApplications(updatedApplications);
//         gedata();
//       })
//       .catch(error => console.log(error));

     

      


//   };

//   const handleInputChange = (applicationno, field, value) => {
//     setLeaveUpdates(prev => ({
//       ...prev,
//       [applicationno]: { ...prev[applicationno], [field]: value }
//     }));
//   };

//   const columns = [
//     { field: 'applicationno', headerName: 'ID', flex: 1 },
//     { field: 'leavetype', headerName: 'Leave Type', flex: 1 },
//     { field: 'startingdate', headerName: 'Start Date', flex: 1 },
//     { 
//       field: 'startingdateleavesession', 
//       headerName: 'Half Day', 
//       flex: 1,
//       renderCell: (params) => params.value === "AM" ? "First Half" : params.value === "PM" ? "Second Half" : "-" 
//     },
//     { field: 'endingdate', headerName: 'End Date', flex: 1 },
//     { field: 'ApplyingDate', headerName: 'Applying Date', flex: 1 },
//     { 
//       field: 'LeavePurpose', 
//       headerName: 'Reason', 
//       flex: 1,
//       renderCell: (params) => {
//         const maxLength = 12;
//         return params.value.length > maxLength ? (
//           <Tooltip title={params.value}><div>{params.value}</div></Tooltip>
//         ) : <div>{params.value}</div>;
//       }
//     },
//     { field: 'userEmail', headerName: 'User Email', flex: 1 },
//     { 
//       field: 'ApplicationStatus', 
//       headerName: 'Status', 
//       flex: 1,
//       renderCell: (params) => {
//         const { ApplicationStatus, startingdate, applicationno } = params.row;
//         const startingDate = new Date(startingdate);
//         const today = new Date();

//         if (ApplicationStatus === 'CANCELLED') {
//           return <div style={{ color: 'red', textAlign: "center" }}>CANCELLED</div>;
//         } else if (ApplicationStatus === 'APPROVED' && startingDate < today) {
//           return <div style={{ color: 'green', textAlign: "center" }}>APPROVED</div>;
//         } else if(params.row.user_want_cancel != undefined   || params.row.user_want_cancel != null ){
               
//           return(
//             <div>  
//             <div>
//             cancellation 
//             </div>
             
//              <select value={params.value} onChange={(e) => handleUpdatecancellation(applicationno, e.target.value)}>
//              <option value="PENDING">PENDING</option>
//              <option value="APPROVED">APPROVE</option>
//              <option value="REJECTED">REJECT</option>
//            </select>


//            </div>


//           )

//         } else {
//           return (
//             <select value={params.value} onChange={(e) => handleUpdate(applicationno, e.target.value)}>
//               <option value="PENDING">PENDING</option>
//               <option value="APPROVED">APPROVE</option>
//               <option value="REJECTED">REJECT</option>
//             </select>
//           );
//         }
//       }
//     },
//     { field: "noofdays", headerName: 'No Of Days', flex: 1 },
//     { 
//       field: "actualapproveleave", 
//       headerName: 'Approved Days', 
//       flex: 1,
//       renderCell: (params) => {
//         const maxDays = params.row.noofdays || 0;
//         const approvedDays = leaveUpdates[params.row.applicationno]?.actualapproveleave || params.value || 0;

//         return (
//           <Select
//             value={approvedDays}
//             onChange={(e) => handleInputChange(params.row.applicationno, 'actualapproveleave', e.target.value)}
//             size="small"
//             variant="standard"
//           >
//             {[...Array(maxDays + 1).keys()].map(day => (
//               <MenuItem key={day} value={day}>{day}</MenuItem>
//             ))}
//           </Select>
//         );
//       }
//     },
//     { 
//       field: "comments", 
//       headerName: 'Comments', 
//       flex: 1,
//       renderCell: (params) => (
//         <TextField
//           type="text"
//           variant="standard"
//           size="small"
//           defaultValue={params.value}
//           onChange={(e) => handleInputChange(params.row.applicationno, 'comments', e.target.value)}
//           onKeyDown={(e) => e.stopPropagation()}
//         />
//       )
//     },
//     { field: 'EL', headerName: ' EL', flex: 1 },
//     { field: 'PL', headerName: 'PL ', flex: 1 },
//   ];

//   return (
//     <Box m="20px">
//       <Header title="Approve Leaves" subtitle="List of Leaves" />
//       {message && <Typography variant="body1" sx={{ color: 'green' }}>{message}</Typography>}
//       <Box height="75vh" sx={{
//         "& .MuiDataGrid-root": { border: "none" },
//         "& .MuiDataGrid-cell": { borderBottom: "none" },
//         "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
//         "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
//         "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
//         "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
//         "& .MuiDataGrid-toolbarContainer .MuiButton-text": { color: `${colors.grey[100]} !important` },
//       }}>
//         <DataGrid
//           rows={applications}
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//           pagination
//           pageSize={10}
//           rowsPerPageOptions={[10, 25, 50]}
//           checkboxSelection
//           autoHeight
//           hideFooterSelectedRowCount
//           getRowId={(row) => row.applicationno}

//           getRowClassName={(params) =>
//             params.row.user_want_cancel !== undefined && params.row.user_want_cancel !== null
//               ? "highlight-row"
//               : ""
//           }
//         />
//       </Box>
//     </Box>
//   );
// }

// export default ApproveLeave;











// updated code


// import React, { useState, useEffect } from 'react';
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Typography, Tooltip, TextField, MenuItem, Select } from '@mui/material';
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";
// import { tokens } from "../../theme";
// import "./ApproveLeave.css";

// function ApproveLeave() {
//   const [applications, setApplications] = useState([]);
//   const [message, setMessage] = useState('');
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [leaveUpdates, setLeaveUpdates] = useState({}); // Store updated values for each row
//   const [selectedRows, setSelectedRows] = useState([]); // Track selected rows

//   function gedata() {
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application`)
//       .then(res => res.json())
//       .then(data => {
//         const rowsWithId = data.map((row, index) => ({
//           id: index + 1,
//           ...row,
//           EL: row.emergencyleave, // Add emergencyleave as EL
//           PL: row.plannedleave, 
//           actualapproveleave: row.ActualApproveLeave ?? 0,   // Add plannedleave as PL
//         }));
//         setApplications(rowsWithId);
//       })
//       .catch(error => console.log(error));
//   }

//   useEffect(() => {
//     gedata();
//   }, []);

//   const handleUpdate = (applicationno, status) => {
//     const updatedRow = applications.find(application => application.applicationno === applicationno);
//     const { actualapproveleave, comments } = leaveUpdates[applicationno] || {}; // Get updated values

//     const updatedApplications = applications.map(application =>
//       application.applicationno === applicationno
//         ? { ...application, ApplicationStatus: status, actualapproveleave, comments }
//         : application
//     );

//     const updatedApplicationData = [
//       {
//         applicationno: updatedRow.applicationno,
//         ApplicationStatus: status,
//         userEmail: updatedRow.userEmail,
//         leavetype: updatedRow.leavetype,
//         LeavePurpose: updatedRow.LeavePurpose,
//         noofdays: updatedRow.noofdays,
//         startingdate: updatedRow.startingdate,
//         endingdate: updatedRow.endingdate,
//         startingdateleavesession: updatedRow.startingdateleavesession,
//         endingdateleavesession: updatedRow.endingdateleavesession,
//         ApplyingDate: updatedRow.ApplyingDate,
//         actualapproveleave: actualapproveleave || updatedRow.actualapproveleave, // Use updated or existing value
//         comments: comments || updatedRow.comments, // Use updated or existing value
//       },
//     ];

//     console.log("UPDATED APPLICATION data", updatedApplicationData);

//     const requestOptions = {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(updatedApplicationData),
//     };

//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-update`, requestOptions)
//       .then(res => res.json())
//       .then(() => {
//         setMessage('Status updated successfully');
//         setApplications(updatedApplications);
//         gedata();
//       })
//       .catch(error => console.log(error));
//   };

//   const handleUpdatecancellation = (applicationno, status) => {
//     const updatedRow = applications.find(application => application.applicationno === applicationno);
//     const { actualapproveleave, comments } = leaveUpdates[applicationno] || {}; // Get updated values

//     const updatedApplications = applications.map(application =>
//       application.applicationno === applicationno
//         ? { ...application, ApplicationStatus: status, actualapproveleave, comments }
//         : application
//     );

//     const updatedApplicationData = [
//       {
//         applicationno: updatedRow.applicationno,
//         ApplicationStatus: status,
//         userEmail: updatedRow.userEmail,
//         leavetype: updatedRow.leavetype,
//         LeavePurpose: updatedRow.LeavePurpose,
//         noofdays: updatedRow.noofdays,
//         startingdate: updatedRow.startingdate,
//         endingdate: updatedRow.endingdate,
//         startingdateleavesession: updatedRow.startingdateleavesession,
//         endingdateleavesession: updatedRow.endingdateleavesession,
//         ApplyingDate: updatedRow.ApplyingDate,
//         actualapproveleave: actualapproveleave || updatedRow.actualapproveleave, // Use updated or existing value
//         comments: comments || updatedRow.comments, // Use updated or existing value
//       },
//     ];

//     console.log("UPDATED APPLICATION data", updatedApplicationData);

//     const requestOptions = {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(updatedApplicationData),
//     };

//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-update-cancellation`, requestOptions)
//       .then(res => res.json())
//       .then(() => {
//         setMessage('Status updated successfully');
//         setApplications(updatedApplications);
//         gedata();
//       })
//       .catch(error => console.log(error));
//   };

//   const handleInputChange = (applicationno, field, value) => {
//     setLeaveUpdates(prev => ({
//       ...prev,
//       [applicationno]: { ...prev[applicationno], [field]: value }
//     }));
//   };

//   const handleRowSelection = (selection) => {
//     setSelectedRows(selection);
//   };

//   const handleCommentChange = (applicationno, value) => {
//     setLeaveUpdates(prev => ({
//       ...prev,
//       [applicationno]: {
//         ...prev[applicationno],
//         comments: value, // Update the comment inside leaveUpdates
//       },
//     }));
//   };

//   const columns = [
//     { field: 'applicationno', headerName: 'ID', flex: 1 },
//     { field: 'leavetype', headerName: 'Leave Type', flex: 1 },
//     { field: 'startingdate', headerName: 'Start Date', flex: 1 },
//     {
//       field: 'startingdateleavesession',
//       headerName: 'Half Day',
//       flex: 1,
//       renderCell: (params) => params.value === "AM" ? "First Half" : params.value === "PM" ? "Second Half" : "-"
//     },
//     { field: 'endingdate', headerName: 'End Date', flex: 1 },
//     { field: 'ApplyingDate', headerName: 'Applying Date', flex: 1 },
//     {
//       field: 'LeavePurpose',
//       headerName: 'Reason',
//       flex: 1,
//       renderCell: (params) => {
//         const maxLength = 12;
//         return params.value.length > maxLength ? (
//           <Tooltip title={params.value}><div>{params.value}</div></Tooltip>
//         ) : <div>{params.value}</div>;
//       }
//     },
//     { field: 'userEmail', headerName: 'User Email', flex: 1 },
//     {
//       field: 'ApplicationStatus',
//       headerName: 'Status',
//       flex: 1,
//       renderCell: (params) => {
//         const { ApplicationStatus, startingdate, applicationno } = params.row;
//         const startingDate = new Date(startingdate);
//         const today = new Date();

//         if (ApplicationStatus === 'CANCELLED') {
//           return <div style={{ color: 'red', textAlign: "center" }}>CANCELLED</div>;
//         } else if (ApplicationStatus === 'APPROVED' && startingDate < today) {
//           return <div style={{ color: 'green', textAlign: "center" }}>APPROVED</div>;
//         } else if (params.row.user_want_cancel != undefined || params.row.user_want_cancel != null) {
//           return (
//             <div>
//               <div>cancellation</div>
//               <select value={params.value} onChange={(e) => handleUpdatecancellation(applicationno, e.target.value)}>
//                 <option value="PENDING">PENDING</option>
//                 <option value="APPROVED">APPROVE</option>
//                 <option value="REJECTED">REJECT</option>
//               </select>
//             </div>
//           );
//         } else {
//           return (
//             <select value={params.value} onChange={(e) => handleUpdate(applicationno, e.target.value)}>
//               <option value="PENDING">PENDING</option>
//               <option value="APPROVED">APPROVE</option>
//               <option value="REJECTED">REJECT</option>
//             </select>
//           );
//         }
//       }
//     },
//     { field: "noofdays", headerName: 'No Of Days', flex: 1 },
//     {
//       field: "actualapproveleave",
//       headerName: 'Approved Days',
//       flex: 1,
//       renderCell: (params) => {
//         const maxDays = params.row.noofdays || 0;
//         const approvedDays = leaveUpdates[params.row.applicationno]?.actualapproveleave 
//           ?? params.row.actualapproveleave 
//           ?? 0; // Use correct field with default
    
//         return (
//           <Select
//             value={approvedDays}
//             onChange={(e) => handleInputChange(params.row.applicationno, 'actualapproveleave', e.target.value)}
//             size="small"
//             variant="standard"
//           >
//             {[...Array(maxDays + 1).keys()].map(day => (
//               <MenuItem key={day} value={day}>{day}</MenuItem>
//             ))}
//           </Select>
//         );
//       }
//     },
//     { field: 'EL', headerName: ' EL', flex: 1 },
//     { field: 'PL', headerName: 'PL ', flex: 1 },
//   ];

//   return (
//     <Box m="20px">
//       <Header title="Approve Leaves" subtitle="List of Leaves" />
//       {message && <Typography variant="body1" sx={{ color: 'green' }}>{message}</Typography>}
//       <Box  sx={{
//         "& .MuiDataGrid-root": { border: "none" },
//         "& .MuiDataGrid-cell": { borderBottom: "none" },
//         "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
//         "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
//         "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
//         "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
//         "& .MuiDataGrid-toolbarContainer .MuiButton-text": { color: `${colors.grey[100]} !important` },
//       }}>
//         <DataGrid
//           rows={applications}
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//           checkboxSelection
//           autoHeight
//           hideFooterSelectedRowCount
//           onSelectionModelChange={(newSelection) => handleRowSelection(newSelection)}
//           getRowId={(row) => row.applicationno}
//           getRowClassName={(params) =>
//             params.row.user_want_cancel !== undefined && params.row.user_want_cancel !== null
//               ? "highlight-row"
//               : ""
//           }
//         />
//       </Box>

//       {selectedRows.length > 0 && (
//         <Box mt={10} p={2} sx={{ backgroundColor: colors.primary[300], borderRadius: "8px" }}>
//           <Typography variant="h6">Add Comments for Selected Leave Requests</Typography>
//           {selectedRows.map((id) => (
//             <Box key={id} mt={1}>
//               <Typography variant="body1">Application No: {id}</Typography>
//               <TextField
//                 fullWidth
//                 variant="outlined"
//                 size="small"
//                 value={leaveUpdates[id]?.comments || ""}
//                 onChange={(e) => handleCommentChange(id, e.target.value)}
//                 placeholder="Enter comment"
//               />
//             </Box>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// }

// export default ApproveLeave;





import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';
import { Box, Typography, Tooltip, TextField, MenuItem, Select,FormControl, InputLabel, Tabs, Tab } from '@mui/material';
import Header from "../../components/Header";
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import "./ApproveLeave.css";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function ApproveLeave() {
  const [applications, setApplications] = useState([]);
  const [message, setMessage] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filterStatus, setFilterStatus] = useState("PENDING"); // Default: Pending
  const [filteredRows, setFilteredRows] = useState(applications);
  const [startDate, setStartDate] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0); 
  const navigate = useNavigate();
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  function gedata() {
    setLoading(true);
    const cachedData = sessionStorage.getItem('applications');
    
    if (cachedData) {
      setApplications(JSON.parse(cachedData)); // Use cached data instantly 
    }

    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => res.json())
      .then(data => {
        const rowsWithId = data.map((row, index) => ({
          id: index + 1,
          ...row,
          EL: row.emergencyleave, // Add emergencyleave as EL
          PL: row.plannedleave, // Add plannedleave as PL
          username: row.username ?? "-",
          actualapproveleave: row.ActualApproveLeave ?? 0, 
          ApprovedStartingDate: row.ApprovedStartingDate ?? "-",  
          ApprovedEndingDate: row.ApprovedEndingDate ?? "-",
        }));
        console.log("Processed Data for Table:", rowsWithId);
        sessionStorage.setItem('applications', JSON.stringify(rowsWithId));
        setApplications(rowsWithId);
        setLoading(false);
      
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      }
      
    );
    }
    
  useEffect(() => {
    gedata();
  }, []);



  const handleRowSelection = (newSelection) => {
    if (newSelection.length > 0) {
        const selectedId = newSelection[0]; // Get the first selected row's ID
        localStorage.setItem("selectedEmployeeId", selectedId);
        navigate(`/leave-details/${selectedId}`);
    }
  };

  // const filteredApplications = applications.filter((application) => {
  //   if (tabIndex === 0) {
  //     // Tab 0: Emergency & Planned
  //     return (
  //       (application.leaveType === "Emergency" || application.leaveType === "Planned") &&
  //       (application.status === selectedStatus)
  //     );
  //   } else if (tabIndex === 1) {
  //     // Tab 1: Tentative
  //     return (
  //       application.leaveType === "Tentative" &&
  //       (application.status === "Tentative" || application.status === "Pending")
  //     );
  //   }
  // });
  
    useEffect(() => {
      let filteredData = Array.isArray(applications) ? [...applications] : [];

      if (tabValue === 1) {
        // Filter for Tentative Leaves
        filteredData = filteredData.filter(app => app.leavetype === "TL");

        if (filterStatus && filterStatus.trim().toUpperCase() === "PENDING") {
          // Include both PENDING and TENTATIVE statuses
          filteredData = filteredData.filter(app =>
            app.ApplicationStatus &&
            ["PENDING", "TENTATIVE"].includes(app.ApplicationStatus.trim().toUpperCase())
          );
        } else if (filterStatus && filterStatus.trim().toUpperCase() !== "ALL") {
          filteredData = filteredData.filter(app =>
            app.ApplicationStatus &&
            app.ApplicationStatus.trim().toUpperCase() === filterStatus.trim().toUpperCase()
          );
        }
      } else {
        // Exclude Tentative Leaves
        filteredData = filteredData.filter(app => app.leavetype !== "TL");

        if (filterStatus && filterStatus.trim().toUpperCase() !== "ALL") {
          filteredData = filteredData.filter(app =>
            app.ApplicationStatus &&
            app.ApplicationStatus.trim().toUpperCase() === filterStatus.trim().toUpperCase()
          );
        }
      }

      if (startDate) {
        filteredData = filteredData.filter((app) =>
          app.startingdate && new Date(app.startingdate) >= new Date(startDate)
        );
      }

      if (emailFilter.trim()) {
        filteredData = filteredData.filter((app) =>
          (app.userEmail || "").toLowerCase().includes(emailFilter.trim().toLowerCase())
        );
      }

      const priorityOrder = {
        "PENDING": 1,
        "APPROVED": 3,
        "CANCEL-PENDING": 2,
        "REJECTED": 4,
        "CANCELLED": 5,
        "CANCEL_REJECTED": 6,
      };

      const priorityOrderOfTentative = {
        "TENTATIVE": 2,
        "PENDING": 1,
        "CANCEL-PENDING": 3,
        "APPROVED": 4,
        "REJECTED": 5,
        "CANCELLED": 6,
        "CANCEL_REJECTED": 7,
      };

      if (tabValue === 0) {
        // Sorting for tab 0 based on priorityOrder
        filteredData.sort((a, b) => {
          return (priorityOrder[a.ApplicationStatus?.toUpperCase()] || 99) - (priorityOrder[b.ApplicationStatus?.toUpperCase()] || 99);
        });
      } else if (tabValue === 1) {
        // Sorting for tab 1 based on priorityOrderOfTentative
        filteredData.sort((a, b) => {
          return (priorityOrderOfTentative[a.ApplicationStatus?.toUpperCase()] || 99) - (priorityOrderOfTentative[b.ApplicationStatus?.toUpperCase()] || 99);
        });
      }

      setFilteredRows(filteredData);
    }, [filterStatus, startDate, emailFilter, applications, tabValue]);

    const handleTabChange = (event, newValue) => {
      setTabValue(newValue);
    };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
      <GridToolbarExport />
    </GridToolbarContainer>
  );
  
  const columns = [

    { field: 'username', headerName: 'user name ', flex: 1 },

   {
      field: "leavetype",
      headerName: "Leave Type",
      flex: 1,
      valueGetter: (params) => {
        const type = params.row.leavetype;
        if (type === "EL") return "Emergency Leave";
        if (type === "PL") return "Planned Leave";
        if (type === "TL" || type === "Tentative_Leave_Plan") return "Tentative Leave";
        return type;
      }
    },

    {
      field: 'LeavePurpose',
      headerName: 'Reason',
      flex: 1,
      renderCell: (params) => {
        const maxLength = 12;
        return params.value.length > maxLength ? (
          <Tooltip title={params.value}><div>{params.value}</div></Tooltip>
        ) : <div>{params.value}</div>;
      }
    },
  
    {
      field: 'ApplicationStatus',
      headerName: 'Status',
      flex: 1,

      renderCell: (params) => {

        const { ApplicationStatus } = params.row;
        return (
          <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            color:
              ApplicationStatus === "APPROVED"
                ? "#28A745" // Green
                : ApplicationStatus === "CANCELLED"
                ? "#FF6F61" // Red
                : ApplicationStatus === "REJECTED"
                ? "#D32F2F" // Dark Red / Maroon
                : ApplicationStatus === "CANCEL-PENDING"
                ? "#FD7E14" // Orange
                : ApplicationStatus === "PENDING"
                ? "#007BFF" // Blue
                : "#E67E22", // Default Orange
          }}
        >
          {ApplicationStatus}
        </div>
        );
      }
    },
    
    { field: 'EL', headerName: 'Emergency Leave Remaining', flex: 1 },
    { field: 'PL', headerName: 'Planned Leave Remaining', flex: 1 },
  ];

  return (
    <Box m="20px">
      <Header title="Approve Leaves" subtitle="List of Leaves" />
      {message && <Typography variant="body1" sx={{ color: 'green' }}>{message}</Typography>}
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="fullWidth"
        textColor="inherit"
        indicatorColor="secondary"
        TabIndicatorProps={{
          style: {
            height: "4px",
            backgroundColor: colors.greenAccent[600],
            borderRadius: '2px 2px 0 0',
          },
        }}
        sx={{
          mb: 4,
          backgroundColor: theme.palette.background.default,
          borderRadius: "8px",
          borderBottom: `1px solid ${colors.grey[300]}`,
           }}
      >
        <Tab label="All Leaves" />
        <Tab label="Tentative Leaves" />
      </Tabs>
      

        <FormControl style={{ marginBottom: 10, width: 250 }} variant="outlined">
          <InputLabel
            id="status-filter-label"
            shrink
            sx={{
              fontWeight: "bold",
              fontSize: "20px",
              color: "text.primary",
              transform: "translate(14px, -9px) scale(0.75)",
              transformOrigin: "top left",
              "&.Mui-focused": {
                color: "text.primary",
              },
            }}
          >
            Status Filter
          </InputLabel>

          <Select
            labelId="status-filter-label"
            id="status-filter"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            label="Status Filter"
            sx={{
              fontWeight: "bold",
              borderRadius: "8px",
              fontSize: "14px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "& .MuiSvgIcon-root": { color: "#666" },
            }}
          >
            <MenuItem value="PENDING">Pending</MenuItem>
            {tabValue === 1 && <MenuItem value="Tentative">Tentative</MenuItem>}
            <MenuItem value="APPROVED">Approved</MenuItem>
            <MenuItem value="REJECTED">Rejected</MenuItem>
            <MenuItem value="CANCEL-PENDING">Cancel Pending</MenuItem>
            <MenuItem value="CANCELLED">Cancelled</MenuItem>
            <MenuItem value="CANCEL_REJECTED">Cancel-rejected</MenuItem>
            <MenuItem value="All">All</MenuItem>
          </Select>
        </FormControl>


      {/* Start Date Filter */}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <FormControl sx={{ marginBottom: 2, width: 250, ml: 4 }}>
          <DatePicker
            label="Start Date"
            value={startDate ? new Date(startDate) : null}
            onChange={(newValue) => {
              if (newValue instanceof Date && !isNaN(newValue)) {
                const formattedDate = newValue.toISOString().split("T")[0]; // "YYYY-MM-DD"
                setStartDate(formattedDate);
              } else {
                setStartDate("");
              }
            }}
            slotProps={{
              textField: {
                variant: "outlined",
                size: "medium",
                InputLabelProps: {
                  shrink: true,
                },
                sx: {
                  "& label": {
                    color: "text.primary",
                    fontWeight: "bold",
                    
                    transform: "translate(14px, -9px) scale(0.75)",
                    transformOrigin: "top left",
                    fontSize: "20px",
                  },
                  "& label.Mui-focused": {
                    color: "text.primary",
                  },
                  "& .MuiInputBase-root": {
                    color: "text.primary",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid gray",
                  },
                  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid gray",
                  },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid gray",
                  },
                  "& .MuiSvgIcon-root": {
                    color: (theme) => theme.palette.text.primary,
                    
                  },
                },
              },
            }}
          />

        </FormControl>
      </LocalizationProvider>

      {/* Email Filter */}
      <FormControl sx={{ marginBottom: 2, width: 250, ml: 4 }}>

        <TextField
          label="Email"
          type="text"
          value={emailFilter}
          placeholder="Enter..."
          
          onChange={(e) => setEmailFilter(e.target.value)}
          InputLabelProps={{
            shrink: true, // Always keep label visible
          }}
          sx={{
            
            // Label styles
            "& label": {
              color: "text.primary",
              fontWeight: "bold",
              fontSize: "20px",
              transform: "translate(14px, -9px) scale(0.75)",
              transformOrigin: "top left",
            },
            "& label.Mui-focused": {
              color: "text.primary",
            },

            // Input styles
            "& .MuiInputBase-root": {
              color: "text.primary", // use theme text color
              borderRadius: "5px",
              fontWeight: "bold",
              fontSize: "14px",
            },

            // Border styles (apply on root with state selectors)
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
              border: "1px solid gray",
            },
            "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
              border: "1px solid gray",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "1px solid gray",
            },
          }}
        />
      </FormControl>





      <Box  sx={{
        "& .MuiDataGrid-root": { border: "none" },
        "& .MuiDataGrid-cell": { borderBottom: "none" },
        "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
        "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
        "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
        "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": { color: `${colors.grey[100]} !important` },
        
      }}>
        
        <DataGrid
          rows={loading ? [] : filteredRows}
          columns={columns}
          components={{ Toolbar: CustomToolbar }}
          checkboxSelection
          autoHeight
          hideFooterSelectedRowCount
          onSelectionModelChange={(newSelection) => handleRowSelection(newSelection)}
          getRowId={(row) => row.applicationno}
          loading={loading}
          localeText={{ noRowsLabel: loading ? "Loading..." : "" }}
          sx={{
            "& .MuiCircularProgress-root": {
              color: "white !important", // Change loader color to white
            },
          }}
          // getRowClassName={(params) =>
          //   params.row.user_want_cancel !== undefined && params.row.user_want_cancel !== null
          //     ? "highlight-row"
          //     : ""
          // }
        />
    </Box>    
  </Box>
  
  
);

}


export default ApproveLeave;